import { get } from '@/utils/request';

export const partners = (params) => {
  return get('/api/v1/partners', params);
};
